import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var RoundBulletsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M9.81341 8.79412C11.4219 8.79412 12.7258 7.49048 12.7258 5.88235C12.7258 4.27423 11.4219 2.97059 9.81341 2.97059C8.20492 2.97059 6.90099 4.27423 6.90099 5.88235C6.90099 7.49048 8.20492 8.79412 9.81341 8.79412Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81341 3.94118C8.74109 3.94118 7.87179 4.81027 7.87179 5.88235C7.87179 6.95444 8.74109 7.82353 9.81341 7.82353C10.8857 7.82353 11.755 6.95444 11.755 5.88235C11.755 4.81027 10.8857 3.94118 9.81341 3.94118ZM5.93018 5.88235C5.93018 3.73819 7.66876 2 9.81341 2C11.9581 2 13.6967 3.73819 13.6967 5.88235C13.6967 8.02652 11.9581 9.76471 9.81341 9.76471C7.66876 9.76471 5.93018 8.02652 5.93018 5.88235Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M9.81341 26.9118C11.4219 26.9118 12.7258 25.6081 12.7258 24C12.7258 22.3919 11.4219 21.0882 9.81341 21.0882C8.20492 21.0882 6.90099 22.3919 6.90099 24C6.90099 25.6081 8.20492 26.9118 9.81341 26.9118Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81341 22.0588C8.74109 22.0588 7.87179 22.9279 7.87179 24C7.87179 25.0721 8.74109 25.9412 9.81341 25.9412C10.8857 25.9412 11.755 25.0721 11.755 24C11.755 22.9279 10.8857 22.0588 9.81341 22.0588ZM5.93018 24C5.93018 21.8558 7.66876 20.1176 9.81341 20.1176C11.9581 20.1176 13.6967 21.8558 13.6967 24C13.6967 26.1442 11.9581 27.8824 9.81341 27.8824C7.66876 27.8824 5.93018 26.1442 5.93018 24Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M9.81341 45.0294C11.4219 45.0294 12.7258 43.7258 12.7258 42.1176C12.7258 40.5095 11.4219 39.2059 9.81341 39.2059C8.20492 39.2059 6.90099 40.5095 6.90099 42.1176C6.90099 43.7258 8.20492 45.0294 9.81341 45.0294Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81341 40.1765C8.74109 40.1765 7.87179 41.0456 7.87179 42.1176C7.87179 43.1897 8.74109 44.0588 9.81341 44.0588C10.8857 44.0588 11.755 43.1897 11.755 42.1176C11.755 41.0456 10.8857 40.1765 9.81341 40.1765ZM5.93018 42.1176C5.93018 39.9735 7.66876 38.2353 9.81341 38.2353C11.9581 38.2353 13.6967 39.9735 13.6967 42.1176C13.6967 44.2618 11.9581 46 9.81341 46C7.66876 46 5.93018 44.2618 5.93018 42.1176Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8291 5.88235C16.8291 5.34631 17.2638 4.91176 17.7999 4.91176H41.0994C41.6355 4.91176 42.0702 5.34631 42.0702 5.88235C42.0702 6.41839 41.6355 6.85294 41.0994 6.85294H17.7999C17.2638 6.85294 16.8291 6.41839 16.8291 5.88235Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8291 24C16.8291 23.464 17.2638 23.0294 17.7999 23.0294H41.0994C41.6355 23.0294 42.0702 23.464 42.0702 24C42.0702 24.536 41.6355 24.9706 41.0994 24.9706H17.7999C17.2638 24.9706 16.8291 24.536 16.8291 24Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8291 42.1176C16.8291 41.5816 17.2638 41.1471 17.7999 41.1471H41.0994C41.6355 41.1471 42.0702 41.5816 42.0702 42.1176C42.0702 42.6537 41.6355 43.0882 41.0994 43.0882H17.7999C17.2638 43.0882 16.8291 42.6537 16.8291 42.1176Z"
  }));
});
RoundBulletsIcon.displayName = 'RoundBulletsIcon';
RoundBulletsIcon.defaultProps = {
  'aria-label': 'RoundBullets'
};
export default RoundBulletsIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/RoundBulletsIcon/index.js
// module id = 1931
// module chunks = 12